import Modal from 'react-modal';
import "../../styles/AdminPage.css";
import Button, { BUTTON_TYPES } from '../Button';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FaTimes } from "react-icons/fa";
import LabeledCheckbox from '../inputs/LabeledCheckBox';
import toast from 'react-hot-toast';
import { deleteEvent, deleteEventRecurrence } from '../../api/admin/AdminDashboardAPI';

Modal.setAppElement('#root');

const EventDeleteModal = ({ isOpen, onClose, event, removeEvent, updateEventWithRecurrence }) => {

    const [isDeleteRecurringEnabled, setIsDeleteRecurringEnabled] = useState(false);

    const handleDeleteRecurringChange = (eventRecurr) => {
        setIsDeleteRecurringEnabled(eventRecurr.target.checked);
    };

    const handleDelete = (eventDel) => {
        try {
            toast.loading("Deleting Event...");
            setTimeout(async () => {
                const response = await deleteEvent(eventDel, isDeleteRecurringEnabled);

                if (response.ok) {
                    toast.dismiss();
                    if (isDeleteRecurringEnabled) {
                        toast.success("Events deleted");
                        updateEventWithRecurrence();
                    } else {
                        toast.success("Event deleted!");
                    }
                    removeEvent(eventDel);
                    onClose();
                } else {
                    toast.dismiss();
                    toast.error("Event failed to delete. Status: " + response.status);
                }
                
            }, 300);
        } catch (error) {
            toast.dismiss();
            console.error("Error deleting event:", error);
            toast.error("Something went wrong. Please check your connection and try again.");
        }
    }


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Event Delete Modal"
            className="custom-modal-content delete-modal"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                    <h2 className="text-start fs-4 mb-0">Are you sure you want to delete this event?</h2>
                    <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                        <button className="close-btn" onClick={onClose}>{<FaTimes />}</button>
                    </div>
                </div>
                {(event.recurrence) && (
                    <div className="d-flex flex-row justify-content-between mb-2">
                        <LabeledCheckbox
                            id="delete-recurring-checkbox"
                            label="Delete All Future Recurrences:"
                            checked={isDeleteRecurringEnabled}
                            onChange={handleDeleteRecurringChange}
                            disabled={false}
                        />
                    </div>
                )}
                <div className='d-flex flex-row justify-content-center align-items-center two-button-container'>
                    <div className='me-3'>
                        <Button
                            id="filter-button-modal"
                            type={BUTTON_TYPES.outline}
                            buttonText="Cancel"
                            action={() => { onClose() }}
                        />
                    </div>
                    <Button
                        id="delete-event-confirm-button"
                        type={BUTTON_TYPES.danger}
                        buttonText="Confirm"
                        action={() => { handleDelete(event) }}
                    />
                </div>
            </>
        </Modal>
    );
};

EventDeleteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object.isRequired,
    removeEvent: PropTypes.func.isRequired,
};

export default EventDeleteModal;
